import type { SizeType } from "@jobteaser/spark/components/Avatar/Avatar"
import type { FunctionComponent } from "react"

import Image from "next/image"

import { Avatar } from "@jobteaser/spark/components/Avatar"
import { User } from "@jobteaser/spark/components/Icons/User"

import styles from "./UserAvatar.module.css"

type UserAvatarProps = {
  size?: Extract<SizeType, 24 | 64>
  src?: string
  alt?: string
}

export const UserAvatar: FunctionComponent<UserAvatarProps> = ({ size = 24, src = "", alt = "User avatar" }) => {
  if (!src) {
    return (
      <Avatar
        size={size}
        shape="rounded"
        fallbackIcon={User}
        className={styles["userAvatar--default"]}
        data-testid="user-avatar-default"
      />
    )
  }

  return (
    <Avatar size={size} shape="rounded">
      <Image src={src} alt={alt} fill className={styles["userAvatar--image"]} data-testid="user-avatar-image" />
    </Avatar>
  )
}
